const PREFIX = "pxp:shop smart toilets:"

const defaultProps = {
  clickInternalLinks: "true",
  eventAction: "n/a",
  eventMsg: "n/a",
  eventName: "n/a",
  eventStatus: "n/a",
  eventType: "navigation",
  internalLinkName: "n/a",
  internalLinkPosition: "n/a",
  internalLinkType: "n/a",
  internalLinkURL: "n/a",
  internalLinkZoneName: "n/a",
}

export const generateInteractionProps = (dynamicValue, overrides = {}) => {
  const propsWithFixedPrefix = `${PREFIX}${dynamicValue}`.toLowerCase()
  const baseProps = {
    eventName: propsWithFixedPrefix,
    eventAction: propsWithFixedPrefix,
    internalLinkZoneName: propsWithFixedPrefix,
  }

  const mergedProps = {
    ...defaultProps,
    ...baseProps,
    ...overrides,
  }

  // Ensure all values are lowercase
  const finalProps = {}
  for (const key in mergedProps) {
    if (Object.hasOwn(mergedProps, key)) {
      const value = mergedProps[key]
      finalProps[key] = typeof value === "string" ? value.toLowerCase() : value
    }
  }

  return finalProps
}
